var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff4B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.41 182.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1299a1;}.cls-2{fill:#07243e;}.cls-3{fill:#0d4775;}.cls-4{fill:#916657;}.cls-5{fill:#232323;}.cls-6{fill:#004568;}.cls-7{fill:#0d5278;}.cls-8{fill:#12adb2;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_01b",
    "data-name": "Staff_Male_01b",
    viewBox: "0 0 81.41 182.59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.53,29.9c5.58-.57,7.87,3.54,8.92,9.1S49.9,55.84,49.9,55.84s14,3,17.86,2.86c0,.51-.7,8.26-.7,8.26-8.75.5-23.81-1.18-26.26-1.69s-5.07-18.86-5.42-24.08S33.63,30.41,38.53,29.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.08 50.79 53.76 76.05 69.69 72.18 81.41 46.07 64.08 50.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "80.19 44.39 62.51 48.94 51.66 74.37 53.76 76.05 64.08 50.79 81.41 46.07 80.19 44.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.58,61.82c-.75,2-.44,3.37,1.49,3.71s2.19-1.1,3.06-3.46,1.23-3.7-1.14-3.7C73.32,58.37,72.11,60.39,71.58,61.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.87,156.46c0,2.35-.7,5.39,0,6.23s5.78,1.35,8.23,2.86,1.76,3,6.48,3.54c5.78.67,8.75-1.69,4-4.55-5-3-6.3-3.7-9.45-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.18,80.49c.35,8.25-1.93,35.88-2.28,45.65s-.7,25.77-.35,29.47-11,6.07-11.38.51.7-22.74.53-32.51-2.45-41.1-2.45-41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.09,166c.17,4.55-1.93,9.43-.18,12.8s5.78,4,8.4,3.71,3-4,2.1-6.91-2.45-7.07-3-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.66,82.79c-.87,10.61-1.18,39.46-2.45,47.84-1.57,10.44-1.75,29.81-1.4,34.19s11.9,6.07,11.73.84,1.22-21.39,2.27-31.49,8.58-30.83,10.33-38.41c1.3-5.61.53-14,.53-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.67,27C39,24.62,43.43,31.75,44.3,37s1.23,40.42,1.4,44-10,3.87-14.35,4.21-15,2.86-15.58-2.7S13,49.1,13,42.7,13.5,30.07,27.67,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.2,24.85c-2.63.33-6.65,2.52-7.53,4.21S29.6,40.34,29.6,40.34l4.9-6.56,5.08,4c-.35-3.71-3.15-11.62-6.65-12.64S28.2,24.85,28.2,24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.35,83.13l4,4.21S26,88.52,27.24,89.7s5.34,4.88,4.46,5.89-5.6-2.19-5.6-2.19a9.55,9.55,0,0,0,1,3.37c.7.84,5.68,3.47,3.85,4.72-2.71,1.85-7.88-.84-9.63-2.36s-2.8-5.56-4.37-7.07-4.73-4.64-4.73-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.12,34.28c3.87.26,6.48,6.91,2.8,15.67s-7.7,17.68-7.7,17.68c.71,4.11,8.23,16.63,10,18.36a15.79,15.79,0,0,0-3.5,2.19,7.69,7.69,0,0,0-2.1,3.71C6.84,85.49.37,72.68,0,69.65s4.9-20.72,6.47-25.6S11,33.94,16.12,34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.77,26.87l1.4-4.55c-3.32-6.06-3.32-10.11-2.45-13.81S25.92.59,32.4,1.27s9.45,3.87,10,7.58S43.6,24.34,41.5,26.2s-6,2-6,2l-1,5.56a17.94,17.94,0,0,1-7-2.53A19.34,19.34,0,0,1,22.77,26.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.17,22.32c-2.36-1.68-4.37-5.3-4.55-10.44S22.77-.16,31.09,0,43.17,4.21,43.87,8s-9,2.28-13.57.68a35,35,0,0,1-1.14,4.88s-1.33-2.48-3.06-.92c-1.31,1.18-1.49,5.81,1.4,6C27.06,20.22,24.17,22.32,24.17,22.32Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation",
    "data-name": "Vask & Sterilisation"
  }, /*#__PURE__*/React.createElement("use", {
    width: 81.41,
    height: 182.59,
    xlinkHref: "#Staff_Male_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff4B);
export default __webpack_public_path__ + "static/media/staff-4-b.4032ba88eca87791a02f605b033f2143.svg";
export { ForwardRef as ReactComponent };